import axios from "axios";
import authHeader from "./auth-header";
import { useDispatch } from "react-redux";
import { setMessage } from "../features/auth/authSlice";

const API_URL = process.env.REACT_APP_API_URL + "/auth/";

const register = (familyname, username, email, password, roles) => {
    console.log(
        JSON.stringify({ familyname, username, email, password, roles })
    );
    return axios.post(API_URL + "signup", {
        familyname,
        username,
        email,
        password,
        roles,
    });
};

const login = (familyname, username, password) => {
    return axios
        .post(API_URL + "signin", {
            familyname,
            username,
            password,
        })
        .then((response) => {
            if (response.data.accessToken) {
                localStorage.setItem("user", JSON.stringify(response.data));
            }

            return response.data;
        })
        .catch((e) => {
            // console.log(e.response.data.message);
            return e.response.data.message;
        });
};

const logout = () => {
    localStorage.removeItem("user");
};

const refresh = () => {
    return axios
        .get(API_URL + "refresh", { headers: authHeader() })
        .then((response) => {
            if (response.data.accessToken) {
                localStorage.removeItem("user");
                localStorage.setItem("user", JSON.stringify(response.data));
            }
            return response.data;
        })
        .catch((e) => {
            console.log(e);
        });
};

const verify = () => {
    return axios.get(API_URL + "verify", { headers: authHeader() });
};

const resetPsw = (email) => {
    return axios
        .post(API_URL + "resetPsw", { email })
        .then((response) => {
            return response;
        })
        .catch((e) => {
            console.log(e);
        });
};

export default {
    register,
    login,
    logout,
    refresh,
    verify,
    resetPsw,
};
